<template>
  <!--Head 1POS 3HarpId 4区域位置 2国家 5省 6城市 7房型-->
  <el-row class="headsyl">
    <el-col :span="2">
      <div>
        <span class="hbefont">HBE配置</span>
      </div>
    </el-col>
    <el-col :span="22">
      <div>
        <span :class="[this.tabName == '1' ? 'clickcolor headerfont' : 'headerfont',]" @click="tabChange('1')">POS</span>
        <span :class="[this.tabName == '10' ? 'clickcolor headerfont' : 'headerfont',]" @click="tabChange('10')">RC</span>
        <span :class="[this.tabName == '2' ? 'clickcolor headerfont' : 'headerfont',]" @click="tabChange('2')">国家</span>
        <span :class="[this.tabName == '5' ? 'clickcolor headerfont' : 'headerfont',]" @click="tabChange('5')">州/省</span>
        <span :class="[this.tabName == '6' ? 'clickcolor headerfont' : 'headerfont',]" @click="tabChange('6')">城市</span>
        <span :class="[this.tabName == '4' ? 'clickcolor headerfont' : 'headerfont',]" @click="tabChange('4')">区域位置</span>
        <span :class="[this.tabName == '7' ? 'clickcolor headerfont' : 'headerfont',]" @click="tabChange('7')">床型</span>
        <span :class="[this.tabName == '8' ? 'clickcolor headerfont' : 'headerfont',]" @click="tabChange('8')">设施</span>
        <span :class="[this.tabName == '3' ? 'clickcolor headerfont' : 'headerfont',]" @click="tabChange('3')">匹配HarpId</span>
        <span :class="[this.tabName == '9' ? 'clickcolor headerfont' : 'headerfont',]" @click="tabChange('9')">酒店集团&渠道</span>
        <!-- <span :class="[this.tabName == '11' ? 'clickcolor headerfont' : 'headerfont',]" @click="tabChange('11')">同步酒店</span> -->
        <span :class="[this.tabName == '12' ? 'clickcolor headerfont' : 'headerfont',]" @click="tabChange('12')">酒店打标</span>
        <span :class="[this.tabName == '13' ? 'clickcolor headerfont' : 'headerfont',]" @click="tabChange('13')">支付方式</span>
        <span :class="[this.tabName == '14' ? 'clickcolor headerfont' : 'headerfont',]" @click="tabChange('14')">短信&邮件通知</span>
        <span :class="[this.tabName == '15' ? 'clickcolor headerfont' : 'headerfont',]" @click="tabChange('15')">虚拟卡</span>
      </div>
    </el-col>
  </el-row>
</template>

<script>
export default {
  name: "HBEHeader",
  data() {
    return {
      tabName: "1",
    };
  },
  methods: {
    tabChange(tab) {
      this.tabName = tab;
      this.$emit("childByValue", this.tabName);
    },
  },
};
</script>

<style scoped>
.headsyl {
  background-color: white;
  margin: 10px 20px;
  display: flex;
  align-items: center;
}
.hbefont {
  font-size: 1.6rem;
  margin-left: 2rem;
}
.clickcolor {
  background-color: rgb(253 237 216);
}

.headerfont {
  font-size: 1.4rem;
  width: 9%;
  display: inline-block;
  margin: 1rem 1rem 1rem 0;
  text-align: center;
}

.headerfont:hover {
  background-color: rgb(253 237 216);
  cursor: pointer;
}
</style>
